/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModMapping: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<g>
				<circle cx='8' cy='2' r='1.5' stroke='#343A40' />
				<circle cx='8' cy='14' r='1.5' stroke='#343A40' />
				<circle cx='14' cy='8' r='1.5' stroke='#343A40' />
				<circle cx='2' cy='8' r='1.5' stroke='#343A40' />
				<path
					d='M3.22875 10.7334C3.71477 11.5799 4.41857 12.2843 5.26488 12.7705C5.12578 13.0795 5.03589 13.4155 5.00903 13.7695C3.82008 13.1519 2.84614 12.1793 2.22875 10.9902C2.58332 10.9635 2.91927 10.8727 3.22875 10.7334ZM12.7707 10.7334C13.0799 10.8726 13.4156 10.9633 13.7698 10.9902C13.1523 12.1792 12.1794 13.1521 10.9905 13.7695C10.9636 13.4153 10.8729 13.0797 10.7336 12.7705C11.5804 12.2843 12.2845 11.5801 12.7707 10.7334ZM5.00903 2.22852C5.03575 2.58289 5.1257 2.91917 5.26488 3.22852C4.41884 3.71456 3.71479 4.41861 3.22875 5.26465C2.91941 5.12546 2.58313 5.03551 2.22875 5.00879C2.84626 3.8197 3.81994 2.84602 5.00903 2.22852ZM10.9905 2.22852C12.1795 2.84591 13.1522 3.81984 13.7698 5.00879C13.4158 5.03566 13.0798 5.12554 12.7707 5.26465C12.2845 4.41833 11.5801 3.71454 10.7336 3.22852C10.873 2.91903 10.9637 2.58309 10.9905 2.22852Z'
				/>
			</g>
			<defs>
				<clipPath id='clip0_6713_2424'>
					<rect width='16' height='16' fill='white' />
				</clipPath>
			</defs>
		</Svg>
	);
};

export { ModMapping };
